import { useState, useEffect } from 'react';
import createApolloClient from '../../../api';
import getAllFaqs from '../../../api/queries/faqs/getAllFaqs';
import sanitizeHTML from '../../../utils/sanitiseHTML';


const client = createApolloClient();

const Faq = () => {
  const [faqData, setFaqData] = useState([]);

  useEffect(() => {
    (async () => {
      const { data: allFaqData } = await client.query(getAllFaqs('general'));
      const { faqs } = allFaqData;
      setFaqData(faqs);
    })();
  }, []);

  return (
    <div className="section__faq">
      {faqData?.nodes?.map((faq) => {
        return (
          <div key={faq.title} id={faq.title.toLowerCase()} className="section__faq__item">
            <h5>{faq.title}</h5>
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(faq.content) }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Faq;
